// extracted by mini-css-extract-plugin
export default {"container":"greeting_container__KZa7R"};